const AUTH_DESTINATIONS = new Map([
  ['account', '/account'],
  ['analyze', '/analyze'],
  ['brief', '/brief'],
  ['journal', '/journal'],
  ['news', '/news'],
  ['positions', '/positions'],
  ['pricing', '/pricing'],
  ['scan', '/scan'],
  ['uoa', '/uoa'],
  ['watchlist', '/watchlist'],
])

export function authDestination(next: string | null): string {
  return next ? AUTH_DESTINATIONS.get(next) ?? '/account' : '/account'
}
